import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';

import LazyLoading from '../../common/components/LazyLoading/LazyLoading'
import { actions as exampleActions } from '../../redux/modules/example';
import { exampleSelector } from '../../redux/selectors/exampleSelector';
import { ExampleWithError } from '../../common/components/Example';
import { ErrorBoundary } from '../../common/components/Utilities';
import TitleElement from '../../common/components/Title/Title'

require('../../../style/index.css');

const LazyHome = Loadable({
  loader: () => import('../../common/components/Example/Example'),
  loading: LazyLoading,
})

const mapStateToProps = state => ({
  example: exampleSelector(state),
});

const mapDispatchToProps = {
  ...exampleActions,
};


function test(arg1, arg2){
  return function(target) {
    target.test1 = function (){
      console.log(arg1)
    };
    target.test2 = function (){};
  }
}

@connect(mapStateToProps, mapDispatchToProps)
class HomeView extends Component {
  static propTypes = {
    example: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.props.getAwesomeCode();
  }

  render() {
    return (
      <Fragment>
         <TitleElement />
      </Fragment>
    )
  }
}

export default HomeView;



// WEBPACK FOOTER //
// ./src/js/views/home/index.jsx